import React, { useEffect, useState } from 'react';
import PostMessageService, {
  BannerOutcome,
} from '../../services/PostMessage';

import { DenialImage } from './DenialStyledComponent';
import DenialImg from '../../assets/images/denial/denial.svg';
import {
  MainButton,
  MainLink,
  Subtitle,
  TextRegular,
  Title,
} from '../../styles/GlobalStyledComponents';
import ViewModeService from './../../services/ViewMode/index';
import CustomerDeviceService from '../../services/CustomerDevice';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';

interface DenialProps {
  loadingEvent: (data: boolean) => void;
}

export const Denial: React.FC<DenialProps> = ({ loadingEvent }) => {
  const { isPostDataMessages } = useMerchant();
  const { creditProposalResult } = useCreditProposalResult();

  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);
  const [isClient, setisClient] = useState<boolean>(false);

  const handleReturn = async () => {
    if (CustomerDeviceService.getCustomerDevice()) {
      window.location.href = 'https://pepperfinance.es/';
    } else {
      if (isApp && device === 'android') {
        window.location.href = 'peppermerchants://home';
      } else {
        PostMessageService.closeCEX();
      }
    }
  };

  useEffect(() => {
    loadingEvent(false);
    if (isPostDataMessages && creditProposalResult) {
      PostMessageService.FinancingDenied(
        creditProposalResult.credit_proposal_id
      );
    }
    if (creditProposalResult) {
      PostMessageService.BannerOutcome(BannerOutcome.DENIED, {
        proposalId: creditProposalResult.credit_proposal_id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === 'APP' ? true : false);
    setDevice(ViewModeService.getDevice());
    setisClient(
      CustomerDeviceService.getCustomerDevice() === 'true' ? true : false
    );
  }, [isApp, device]);

  return (
    <>
      <Title id="denial-title">
        {isClient
          ? '¡Ups! Tú crédito no ha sido aprobado'
          : '¡Ups! La solicitud no ha sido aprobada'}
      </Title>
      {isClient ? (
        <Subtitle>
          Puedes volver a la tienda y seleccionar otro método de pago
        </Subtitle>
      ) : (
        <Subtitle>
          Lo sentimos... con estos datos no podemos aprobar la operación
        </Subtitle>
      )}
      <DenialImage src={DenialImg}></DenialImage>
      {isApp && device === 'ios' ? (
        <MainLink href="peppermerchants://home">Regresar a la tienda</MainLink>
      ) : (
        <MainButton id="denial-return-btn" onClick={handleReturn}>
          {isClient ? 'Cerrar' : 'Regresar'}
        </MainButton>
      )}
    </>
  );
};
